import { shape, string, func, bool } from "prop-types"

const QuestionQuestion = ({
  question,
  label = "Question",
  onQuestionChanged,
  disabled = false
}) => {
  return (
    <div className="f-2">
      <label htmlFor="question" className="required">
        {label}
      </label>
      <input
        disabled={disabled}
        type="text"
        name="question"
        id="question"
        value={question.question}
        onChange={onQuestionChanged}
      />
    </div>
  )
}

QuestionQuestion.propTypes = {
  label: string,
  question: shape({ question: string }),
  onQuestionChanged: func,
  disabled: bool
}

export default QuestionQuestion
